// Localized strings for the Arrangements (Trumpet + Piano) page
var arrangementsText = {
  en: {
    eyebrow: 'Digital Library',
    title: 'Arrangements for Trumpet & Piano',
    subtitle: 'Original arrangements, transcriptions, and acapella works by Isaías Jiménez — instant PDF download for trumpet, with piano accompaniment where indicated.',
    aboutTitle: 'Hand-crafted by a professional artist',
    aboutBody: 'These digital scores are arrangements I have personally created, performed, and recorded throughout my career — from virtuosic showpieces to lyrical classics. Each score is delivered as a high-quality PDF, ready to print or load into ForScore, PiaScore, or any PDF reader.',
    albumTitle: 'From the Album: Art in Trumpet',
    albumSubtitle: 'Scores featured on Isaías Jiménez\'s 2018 debut solo album — virtuosic arrangements for trumpet and piano. Listen on Spotify, then take the music home.',
    listenOnSpotify: 'Listen on Spotify',
    asPlayedTitle: 'As Recorded by Other Artists',
    asPlayedBody: 'Trumpet arrangements as performed by Sergei Nakariakov, Tine Helseth, Bunny Berigan, and Rafael Méndez.',
    soloTitle: 'Solo & Acapella',
    soloBody: 'Solo trumpet versions for practice, audition, or unaccompanied performance.',
    bigBandTitle: 'Big Band',
    bigBandBody: 'Complete big band arrangements with all parts.',
    allTitle: 'All Arrangements'
  },
  es: {
    eyebrow: 'Biblioteca Digital',
    title: 'Arreglos para Trompeta y Piano',
    subtitle: 'Arreglos originales, transcripciones y obras a capela de Isaías Jiménez — descarga instantánea en PDF para trompeta, con acompañamiento de piano cuando se indica.',
    aboutTitle: 'Creado por un artista profesional',
    aboutBody: 'Estas partituras digitales son arreglos que he creado, interpretado y grabado personalmente a lo largo de mi carrera — desde piezas virtuosísticas hasta clásicos líricos. Cada partitura se entrega en PDF de alta calidad, lista para imprimir o cargar en ForScore, PiaScore o cualquier lector de PDF.',
    albumTitle: 'Del Álbum: Art in Trumpet',
    albumSubtitle: 'Partituras incluidas en el álbum debut en solitario de Isaías Jiménez (2018) — arreglos virtuosísticos para trompeta y piano. Escúchalas en Spotify y llévate la música a casa.',
    listenOnSpotify: 'Escuchar en Spotify',
    asPlayedTitle: 'Como lo Interpretaron Otros Artistas',
    asPlayedBody: 'Arreglos para trompeta interpretados por Sergei Nakariakov, Tine Helseth, Bunny Berigan y Rafael Méndez.',
    soloTitle: 'Solo y A Capela',
    soloBody: 'Versiones para trompeta sola, ideales para práctica, audiciones o presentaciones sin acompañamiento.',
    bigBandTitle: 'Big Band',
    bigBandBody: 'Arreglos completos para big band con todas las partes.',
    allTitle: 'Todos los Arreglos'
  },
  ja: {
    eyebrow: 'デジタルライブラリ',
    title: 'トランペット＆ピアノのためのアレンジメント',
    subtitle: 'イサイアス・ヒメネスによるオリジナルアレンジ、編曲、無伴奏作品 — トランペット用のPDFを即時ダウンロード。指定された場合はピアノ伴奏付き。',
    aboutTitle: 'プロのアーティストによる手作りの楽譜',
    aboutBody: 'これらのデジタル楽譜は、私がキャリアを通じて自ら制作、演奏、録音してきたアレンジです。技巧的な作品から叙情的な名曲まで、各楽譜は高品質なPDFで提供され、印刷やForScore、PiaScore、任意のPDFリーダーへの読み込みが可能です。',
    albumTitle: 'アルバム「Art in Trumpet」より',
    albumSubtitle: 'イサイアス・ヒメネスの2018年デビューソロアルバムに収録された楽曲 — トランペットとピアノのための技巧的なアレンジ。Spotifyで聴いて、その音楽を持ち帰りましょう。',
    listenOnSpotify: 'Spotifyで聴く',
    asPlayedTitle: '他のアーティストの演奏版',
    asPlayedBody: 'セルゲイ・ナカリャコフ、ティーネ・ヘルセット、バニー・ベリガン、ラファエル・メンデスによって演奏されたトランペットアレンジ。',
    soloTitle: 'ソロ＆無伴奏',
    soloBody: '練習、オーディション、無伴奏演奏に最適なソロトランペット版。',
    bigBandTitle: 'ビッグバンド',
    bigBandBody: '全パートを含む完全なビッグバンドアレンジ。',
    allTitle: 'すべてのアレンジメント'
  },
  de: {
    eyebrow: 'Digitale Bibliothek',
    title: 'Arrangements für Trompete & Klavier',
    subtitle: 'Originalarrangements, Transkriptionen und Acapella-Werke von Isaías Jiménez — sofortiger PDF-Download für Trompete, mit Klavierbegleitung, wo angegeben.',
    aboutTitle: 'Handgefertigt von einem professionellen Künstler',
    aboutBody: 'Diese digitalen Partituren sind Arrangements, die ich im Laufe meiner Karriere selbst erstellt, aufgeführt und aufgenommen habe — von virtuosen Bravourstücken bis zu lyrischen Klassikern. Jede Partitur wird als hochwertiges PDF geliefert, druckbereit oder zum Laden in ForScore, PiaScore oder jeden anderen PDF-Reader.',
    albumTitle: 'Vom Album: Art in Trumpet',
    albumSubtitle: 'Stücke aus dem 2018 erschienenen Debüt-Soloalbum von Isaías Jiménez — virtuose Arrangements für Trompete und Klavier. Hören Sie auf Spotify und nehmen Sie die Musik mit nach Hause.',
    listenOnSpotify: 'Auf Spotify Anhören',
    asPlayedTitle: 'Wie von Anderen Künstlern Gespielt',
    asPlayedBody: 'Trompeten-Arrangements wie gespielt von Sergei Nakariakov, Tine Helseth, Bunny Berigan und Rafael Méndez.',
    soloTitle: 'Solo & A-cappella',
    soloBody: 'Solo-Trompetenversionen für Übung, Vorspiel oder unbegleiteten Vortrag.',
    bigBandTitle: 'Big Band',
    bigBandBody: 'Komplette Big-Band-Arrangements mit allen Stimmen.',
    allTitle: 'Alle Arrangements'
  },
  fr: {
    eyebrow: 'Bibliothèque Numérique',
    title: 'Arrangements pour Trompette et Piano',
    subtitle: 'Arrangements originaux, transcriptions et œuvres a cappella d\'Isaías Jiménez — téléchargement PDF instantané pour trompette, avec accompagnement piano lorsque indiqué.',
    aboutTitle: 'Conçus par un artiste professionnel',
    aboutBody: 'Ces partitions numériques sont des arrangements que j\'ai personnellement créés, interprétés et enregistrés tout au long de ma carrière — des pièces virtuoses aux classiques lyriques. Chaque partition est livrée en PDF haute qualité, prête à imprimer ou à charger dans ForScore, PiaScore ou tout lecteur PDF.',
    albumTitle: 'Tiré de l\'Album : Art in Trumpet',
    albumSubtitle: 'Partitions présentes sur l\'album solo de début d\'Isaías Jiménez (2018) — arrangements virtuoses pour trompette et piano. Écoutez sur Spotify, puis emportez la musique chez vous.',
    listenOnSpotify: 'Écouter sur Spotify',
    asPlayedTitle: 'Tel que Joué par d\'Autres Artistes',
    asPlayedBody: 'Arrangements pour trompette interprétés par Sergei Nakariakov, Tine Helseth, Bunny Berigan et Rafael Méndez.',
    soloTitle: 'Solo & A Cappella',
    soloBody: 'Versions trompette seule pour la pratique, l\'audition ou la performance non accompagnée.',
    bigBandTitle: 'Big Band',
    bigBandBody: 'Arrangements complets pour big band avec toutes les parties.',
    allTitle: 'Tous les Arrangements'
  },
  it: {
    eyebrow: 'Biblioteca Digitale',
    title: 'Arrangiamenti per Tromba e Pianoforte',
    subtitle: 'Arrangiamenti originali, trascrizioni e brani a cappella di Isaías Jiménez — download PDF immediato per tromba, con accompagnamento di pianoforte dove indicato.',
    aboutTitle: 'Creati da un artista professionista',
    aboutBody: 'Queste partiture digitali sono arrangiamenti che ho personalmente creato, eseguito e registrato nel corso della mia carriera — dai pezzi virtuosistici ai classici lirici. Ogni spartito viene fornito in PDF di alta qualità, pronto per la stampa o per il caricamento su ForScore, PiaScore o qualsiasi lettore PDF.',
    albumTitle: 'Dall\'Album: Art in Trumpet',
    albumSubtitle: 'Spartiti presenti nell\'album solista di debutto di Isaías Jiménez (2018) — arrangiamenti virtuosistici per tromba e pianoforte. Ascolta su Spotify e porta a casa la musica.',
    listenOnSpotify: 'Ascolta su Spotify',
    asPlayedTitle: 'Come Eseguito da Altri Artisti',
    asPlayedBody: 'Arrangiamenti per tromba interpretati da Sergei Nakariakov, Tine Helseth, Bunny Berigan e Rafael Méndez.',
    soloTitle: 'Solo & A Cappella',
    soloBody: 'Versioni per tromba sola, ideali per pratica, audizioni o performance non accompagnate.',
    bigBandTitle: 'Big Band',
    bigBandBody: 'Arrangiamenti completi per big band con tutte le parti.',
    allTitle: 'Tutti gli Arrangiamenti'
  }
};

export default arrangementsText;
